// const { default: SuppliersEdit } = require('./Edit')

export SupplierCreate from './Create'
export SupplierEdit from './Edit'
export SupplierList from './List'
export SupplierQueries from './queries'
